import React from 'react';
import { CardText, CardContainer } from './Styled';

export const StripeActiveCard = ({ card, renderRemove }) => (
  <div>
    <CardContainer flex>
      <CardText>{`${card.brand}:  ending in ${card.last4}`}</CardText>
      <CardText>{`Expiry: ${card.exp_month}/${card.exp_year}`}</CardText>
    </CardContainer>

    {renderRemove()}
  </div>
);

StripeActiveCard.defaultProps = {
  renderRemove: () => null
};

export default StripeActiveCard;
